import "../css/app.css";
import "./bootstrap";

import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createApp, h } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import ElementPlus from "element-plus";
import es from "element-plus/es/locale/lang/es";
import "element-plus/dist/index.css";

import dayjs from "dayjs";
import "dayjs/locale/es"; // Import Spanish locale
// Set the locale to Spanish globally
dayjs.locale("es");

import vueVectorMap from "vuevectormap";
// import "vuevectormap/src/scss/vuevectormap.scss";
import "jsvectormap/dist/maps/world";
import "jsvectormap/dist/maps/world-merc";
import { co_mill, mx_en } from "./Pages/dashboard/MapsData";
import { setupElementECDefaults } from "./plugins/elementPlusECDefaults";

import * as Sentry from "@sentry/vue";

jsVectorMap.addMap("co", co_mill);
jsVectorMap.addMap("mx", mx_en);

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
  title: (title) => `${title} | ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob("./Pages/**/*.vue")
    ),
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });
    const countryCode = props.initialPage.props.countryCode;
    const env = props.initialPage.props.env;

    Sentry.init({
      app,
      dsn:
        countryCode == "MX"
          ? import.meta.env.VITE_SENTRY_LARAVEL_DSN_MX
          : import.meta.env.VITE_SENTRY_LARAVEL_DSN_CO,
      // Adds request headers and IP for users, for more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
      environment: env,
      release: import.meta.env.VITE_SENTRY_RELEASE,
      sendDefaultPii: true,
    });

    setupElementECDefaults();

    return app
      .use(plugin)
      .use(vueVectorMap)
      .use(VueQueryPlugin)
      .use(ZiggyVue)
      .use(ElementPlus, { locale: es })
      .mount(el);
  },
  progress: {
    color: "#4B5563",
  },
});
